export default {
  mediaQueries: {
    sm: '(max-width: 640px)',
    md: '(min-width: 641px) and (max-width: 1024px)',
    lg: '(min-width: 1025px) and (max-width: 1440px)',
    xl: '(min-width: 1441px)'
  }
};
